import type React from "react";
import { createContext, useContext } from "react";
import type {
  MessageProp,
  TerminateRequestProps,
  ModalParams,
} from "interfaces/reports/sharedworker.types";

type SharedWorkerContextType = {
  messages: Map<string, MessageProp>;
  activeModal: string | null;
  setActiveModal: React.Dispatch<React.SetStateAction<string | null>>;
  getMessageByNodeId: (nodeId: string) => MessageProp | undefined;
  startPolling: (
    nodeId: string,
    requestId: string,
    modalParams: ModalParams,
  ) => void;
  terminateRequest: (props: TerminateRequestProps) => void;
};

export const SharedWorkerContext = createContext<SharedWorkerContextType>({
  messages: new Map(),
  activeModal: null,
  setActiveModal: () => {},
  getMessageByNodeId: () => undefined,
  startPolling: () => {},
  terminateRequest: () => {},
});

export const useSharedWorker = () => useContext(SharedWorkerContext);
